var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-orange sm"},[_vm._t("actions")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }